// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishListNew/MajorDetail.less
// module id = 959
// module chunks = 0